import { html, attr, type Signal } from '@tempots/dom'
import type { ActionDetail } from '@/services/types'

export interface ActionDescriptionOptions {
  action: Signal<ActionDetail | null>
}

export function ActionDescription({ action }: ActionDescriptionOptions) {
  return html.section(
    attr.class('bg-white rounded-xl border border-gray-200 p-6'),
    html.h2(
      attr.class('text-base font-semibold text-gray-900 mb-3'),
      'Description'
    ),
    html.p(
      attr.class('text-sm text-gray-600 leading-relaxed'),
      action.map((a) => a?.description ?? '')
    )
  )
}
